module.exports = __webpack_public_path__ + "img/Unsatisfactory.16211f4971ade9b5f8a13f91e5665ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Unsatisfactory.png
// module id = 768
// module chunks = 0